import { render } from "./SimpleHtmlEditor.vue?vue&type=template&id=0e04fc34&scoped=true"
import script from "./SimpleHtmlEditor.vue?vue&type=script&lang=js"
export * from "./SimpleHtmlEditor.vue?vue&type=script&lang=js"

import "./SimpleHtmlEditor.vue?vue&type=style&index=0&id=0e04fc34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e04fc34"]])

export default __exports__